import React from "react";
import { useRouteLoaderData } from "react-router-dom";
import {
  announcementUpdate,
  announcementUpdateLongDescription,
} from "../../../../../api/announcement";
import AnnouncementForm from "./AnnouncementForm";

const announcementUpdateAction = async ({ request }) => {
  const formData = await request.formData();
  const announcementEntityId = formData.get("announcementEntityId");

  const submission = {
    announcementEntityId,
    label: formData.get("label"),
    userEntityId: formData.get("userEntityId"),
  };

  const res = await announcementUpdate({ ...submission });

  if (res.code === "SUCCESS") {
    const oldLongDescription = formData.get("oldLongDescription");
    const newLongDescription = formData.get("longDescription");
    if (encodeURIComponent(newLongDescription) !== oldLongDescription) {
      await announcementUpdateLongDescription(announcementEntityId,
        newLongDescription);
    }
  }
  return res;
};

const AnnouncementUpdateForm = () => {
  const { announcement, longDescription } = useRouteLoaderData(
    "adminAnnouncement");

  return <AnnouncementForm
    announcement={announcement}
    longDescription={longDescription}
  />;
};

export { announcementUpdateAction };
export default AnnouncementUpdateForm;